// Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React, { useState, useMemo } from "react";
import "../../css/Reports.scss";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { ReactComponent as InvoiceSVG } from "../../icons/invoice.svg";
import { ReactComponent as PerDiemSVG } from "../../icons/perdiem.svg";
import Invoices from "./InvoicesReport";
import PerDiemPayments from "./PerDiemPaymentsReport";
import { isAccessGranted } from "../../utils/oauth";
import { PRIVILEGES } from "../../Config";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function Reports() {
  const allowedTabs = useMemo(() => {
    const tabs = [];
    if (isAccessGranted([PRIVILEGES.VIEW_ALL_INVOICES_PAGE])) {
      tabs.push({
        key: "invoices",
        label: (
          <Button
            startIcon={<InvoiceSVG />}
            color="secondary"
            size="small"
            className="Tab-label"
          >
            Invoices
          </Button>
        ),
        component: <Invoices />,
      });
    }

    if (isAccessGranted([PRIVILEGES.VIEW_ALL_PER_DIEM_PAYMENTS_PAGE])) {
      tabs.push({
        key: "per-diem",
        label: (
          <Button
            startIcon={<PerDiemSVG />}
            color="secondary"
            size="small"
            className="Tab-label"
          >
            Per Diem Payments
          </Button>
        ),
        component: <PerDiemPayments />,
      });
    }
    return tabs;
  }, []);

  const [value, setValue] = useState(0);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="Reports">
      <Box className="Reports-box">
        <AppBar position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            textColor="inherit"
          >
            {allowedTabs.map((tab, index) => (
              <Tab key={tab.key} label={tab.label} />
            ))}
          </Tabs>
        </AppBar>
      </Box>

      <div className="Page-title">
        {allowedTabs[value] ? allowedTabs[value].label.props.children : ""}
      </div>

      {allowedTabs.map((tab, index) => (
        <TabPanel key={tab.key} value={value} index={index}>
          {tab.component}
        </TabPanel>
      ))}
    </div>
  );
}

export default Reports;
